import { VehicleType } from './VehicleType';

export interface Vehicle {
    id?: number;
    vehicle_type: string;
    patent: string;
    is_active?: boolean;
    created_at?: string;
    created_user?: string;
}

export interface VehicleDataForm {
    id?: number;
    vehicle_type: string;
    patent: string;
}

export interface VehicleFilters {
    id?: number | null;
    patent?: string | '';
    vehicle_type?: string | '';
    page: number;
    per_page: number;
    sort: string;
    order: string;
}

export const defaultVehicleDataForm: VehicleDataForm = {
    vehicle_type: 'TERRESTRE',
    patent: ''
};

export const vehicleTypeOptions = [
    { value: 'TERRESTRE', label: 'Terrestre' },
    { value: 'AEREO', label: 'Aéreo' },
    { value: 'MARITIMO', label: 'Marítimo' }
];
